import { useTranslation } from 'react-i18next'

import Tag, { type TagColor } from '@/components/Tag/Tag'

import type { SectionStatus } from '../constants/section-status'

const STATUS_TAG_COLORS_MAP: Record<SectionStatus, TagColor> = {
  inactive: 'gray',
  draft: 'blue',
  active: 'green'
}

type SectionStatusTagProps = {
  status: SectionStatus
}

const SectionStatusTag = (props: SectionStatusTagProps) => {
  const { t } = useTranslation('sections')

  return (
    <Tag
      label={t(`status.${props.status}`)}
      color={STATUS_TAG_COLORS_MAP[props.status]}
    />
  )
}

export default SectionStatusTag
